// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Xb42","header":"ClearentDisclaimer_header__2-81N","inner":"ClearentDisclaimer_inner__3rFkD"};